// PageDescription: 의약품 사전 검색 페이지
import useGetKeywordIntegratedSearchDiseaseEncyclopedia, {
  EKeywordSearchDiseaseEncyclopediaSortType,
} from '@/hooks/search/useGetKeywordIntegratedSearchDiseaseEncyclopedia';
import { CustomPageProps } from '@/types/app';
import { withClientServerSideProps } from '@/utils/mobile/RNPlugins';
import {
  DiseaseEncyclopediaSearchView,
  useDiseaseEncyclopediaSearchViewModel,
} from '@/views/disease-encyclopedia/search';
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

const DiseaseEncyclopediaSearchPage = ({ client }: CustomPageProps) => {
  const viewModel = useDiseaseEncyclopediaSearchViewModel();

  return (
    <>
      <NextSeo
        title={'닥터나우 질환백과 목록 - 증상, 원인별 질병 정보 안내'}
        description={
          '원하는 질환 정보를 검색해보세요. 닥터나우 질환백과는 각 질병의 정의부터 치료법까지 모두 확인 가능해요.'
        }
      />
      <DiseaseEncyclopediaSearchView viewModel={viewModel} client={client} />
    </>
  );
};

export default DiseaseEncyclopediaSearchPage;

export const getServerSideProps: GetServerSideProps = withClientServerSideProps(async (context) => {
  const queryClient = new QueryClient();
  const page = Number(context.query.page) || 1;
  const keyword = String(context.query.keyword) || '';

  await Promise.allSettled([
    useGetKeywordIntegratedSearchDiseaseEncyclopedia.prefetchQuery(queryClient, {
      keyword,
      limit: 10,
      page,
      sortType: EKeywordSearchDiseaseEncyclopediaSortType.Score,
    }),
  ]);

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      page,
    },
  };
});
